import { storage } from '../config/firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

const generateThumbnail = async (file) => {
  if (!file.type.startsWith('image/')) {
    return null;
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Calculate thumbnail size (300px max dimension)
        const maxSize = 300;
        let width = img.width;
        let height = img.height;
        
        if (width > height) {
          if (width > maxSize) {
            height = height * (maxSize / width);
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width = width * (maxSize / height);
            height = maxSize;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        ctx.drawImage(img, 0, 0, width, height);
        
        // Convert to blob
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg', 0.7);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

export const uploadBaseMap = async (airportId, file, title) => {
  const fileId = uuidv4();
  const extension = file.name.split('.').pop().toLowerCase();
  const fileType = file.type.startsWith('image/') ? 'image' : 'pdf';
  
  // Upload original file
  const filePath = `airports/${airportId}/base-maps/${fileId}.${extension}`;
  const fileRef = ref(storage, filePath);
  await uploadBytes(fileRef, file);
  const fileUrl = await getDownloadURL(fileRef);

  let thumbnailUrl = null;
  if (fileType === 'image') {
    // Generate and upload thumbnail
    const thumbnail = await generateThumbnail(file);
    if (thumbnail) {
      const thumbnailPath = `airports/${airportId}/base-maps/thumbnails/${fileId}.jpg`;
      const thumbnailRef = ref(storage, thumbnailPath);
      await uploadBytes(thumbnailRef, thumbnail);
      thumbnailUrl = await getDownloadURL(thumbnailRef);
    }
  }

  return {
    id: fileId,
    title,
    fileUrl,
    thumbnailUrl,
    fileType,
    fileName: file.name,
    fileSize: file.size,
    uploadedAt: new Date().toISOString(),
  };
};

export const deleteBaseMap = async (airportId, file) => {
  // Delete original file
  const filePath = `airports/${airportId}/base-maps/${file.id}.${file.fileName.split('.').pop()}`;
  const fileRef = ref(storage, filePath);
  await deleteObject(fileRef);

  // Delete thumbnail if it exists
  if (file.thumbnailUrl) {
    const thumbnailPath = `airports/${airportId}/base-maps/thumbnails/${file.id}.jpg`;
    const thumbnailRef = ref(storage, thumbnailPath);
    await deleteObject(thumbnailRef);
  }
}; 